import {
  ChangeDetectionStrategy,
  Component,
  forwardRef,
  inject,
} from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ChartId } from '@principle-theorem/ng-clinical-charting/store';
import { NgDialogModule } from '@principle-theorem/ng-shared';
import {
  ChartableSurface,
  IChartedItemConfiguration,
  ITooth,
} from '@principle-theorem/principle-core/interfaces';
import { snapshot, WithRef } from '@principle-theorem/shared';
import { BehaviorSubject } from 'rxjs';
import { AvailableSurfacesComponent } from '../add-charted-item-dialog/available-surfaces/available-surfaces.component';
import { CHART_ENTITY_ID } from '../dental-chart-svg/chart-entity-id';

export interface IChartedToothSurfaceUpdateDialogResponse {
  selectedSurfaces: ChartableSurface[];
}

export interface IChartedToothSurfaceUpdateDialogData {
  chartedItemConfiguration: WithRef<IChartedItemConfiguration>;
  tooth: ITooth;
  surfaces: ChartableSurface[];
  selectableSurfaces: ChartableSurface[];
}

@Component({
  selector: 'pr-charted-tooth-surface-update-dialog',
  templateUrl: './charted-tooth-surface-update-dialog.component.html',
  styleUrl: './charted-tooth-surface-update-dialog.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [
    {
      provide: CHART_ENTITY_ID,
      useValue: ChartId.ChartableSurfaces,
    },
  ],
  imports: [NgDialogModule, forwardRef(() => AvailableSurfacesComponent)],
})
export class ChartedToothSurfaceUpdateDialogComponent {
  private _dialogRef = inject(
    MatDialogRef<
      ChartedToothSurfaceUpdateDialogComponent,
      IChartedToothSurfaceUpdateDialogResponse
    >
  );
  data = inject<IChartedToothSurfaceUpdateDialogData>(MAT_DIALOG_DATA);
  selectedSurfaces$ = new BehaviorSubject<ChartableSurface[]>([]);

  async save(): Promise<void> {
    const selectedSurfaces = await snapshot(this.selectedSurfaces$);
    this._dialogRef.close({
      selectedSurfaces,
    });
  }
}
